<div class="min-h-screen">
  <div class="mx-auto">
    <p-toast />
    <div class="card text-center mb-12">
      <h1 class="text-4xl font-bold text-gray-800 dark:text-white mb-4">
        Traitement d'Hygiène
      </h1>
      <p class="text-lg text-gray-600 dark:text-gray-300 font-medium">
        Lancez les opérations de vérification et de nettoyage des données
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <!-- Category Check -->
      <div class="bg-white dark:bg-zinc-800 rounded-2xl shadow-xl p-6 border border-zinc-100 dark:border-zinc-700 flex flex-col">
        <div class="flex items-center mb-4">
          <div class="bg-blue-100 dark:bg-blue-900 p-3 rounded-full mr-3 w-12 h-12 flex items-center justify-center">
            <i class="pi pi-tags text-2xl text-blue-600 dark:text-blue-400"></i>
          </div>
          <h3 class="text-xl font-bold text-gray-800 dark:text-white">
            Vérification des Catégories
          </h3>
        </div>
        
        <div class="flex-1 flex items-center justify-center my-8">
          <i *ngIf="!loadingStates[BackgroundJobType.CATEGORY]" class="pi pi-check-circle text-green-500 dark:text-green-400" style="font-size: 4rem;"></i>
          <i *ngIf="loadingStates[BackgroundJobType.CATEGORY]" class="pi pi-spin pi-spinner text-blue-500" style="font-size: 4rem;"></i>
        </div>

        <p-button
          label="Lancer"
          icon="pi pi-play"
          [disabled]="loadingStates[BackgroundJobType.CATEGORY]"
          (click)="launchCategoryCheck()"
          class="w-full"
          styleClass="w-full"
        />
      </div>

      <!-- Duplicates Check -->
      <div class="bg-white dark:bg-zinc-800 rounded-2xl shadow-xl p-6 border border-zinc-100 dark:border-zinc-700 flex flex-col">
        <div class="flex items-center mb-4">
          <div class="bg-purple-100 dark:bg-purple-900 p-3 rounded-full mr-3 w-12 h-12 flex items-center justify-center">
            <i class="pi pi-copy text-2xl text-purple-600 dark:text-purple-400"></i>
          </div>
          <h3 class="text-xl font-bold text-gray-800 dark:text-white">
            Vérification des Doublons
          </h3>
        </div>
        
        <div class="flex-1 flex items-center justify-center my-8">
          <i *ngIf="!loadingStates[BackgroundJobType.DUPLICATES]" class="pi pi-check-circle text-green-500 dark:text-green-400" style="font-size: 4rem;"></i>
          <i *ngIf="loadingStates[BackgroundJobType.DUPLICATES]" class="pi pi-spin pi-spinner text-purple-500" style="font-size: 4rem;"></i>
        </div>

        <p-button
          label="Lancer"
          icon="pi pi-play"
          [disabled]="loadingStates[BackgroundJobType.DUPLICATES]"
          (click)="launchDuplicatesCheck()"
          class="w-full"
          styleClass="w-full"
        />
      </div>

      <!-- Search WorkOrder Candidates -->
      <div class="bg-white dark:bg-zinc-800 rounded-2xl shadow-xl p-6 border border-zinc-100 dark:border-zinc-700 flex flex-col">
        <div class="flex items-center mb-4">
          <div class="bg-green-100 dark:bg-green-900 p-3 rounded-full mr-3 w-12 h-12 flex items-center justify-center">
            <i class="pi pi-search text-2xl text-green-600 dark:text-green-400"></i>
          </div>
          <h3 class="text-xl font-bold text-gray-800 dark:text-white">
            Recherche de Candidats
          </h3>
        </div>
        
        <div class="flex-1 flex items-center justify-center my-8">
          <i *ngIf="!loadingStates[BackgroundJobType.SEARCH]" class="pi pi-check-circle text-green-500 dark:text-green-400" style="font-size: 4rem;"></i>
          <i *ngIf="loadingStates[BackgroundJobType.SEARCH]" class="pi pi-spin pi-spinner text-green-500" style="font-size: 4rem;"></i>
        </div>

        <p-button
          label="Lancer"
          icon="pi pi-play"
          [disabled]="loadingStates[BackgroundJobType.SEARCH]"
          (click)="launchSearchCandidates()"
          class="w-full"
          styleClass="w-full"
        />
      </div>

      <!-- Priority Check -->
      <div class="bg-white dark:bg-zinc-800 rounded-2xl shadow-xl p-6 border border-zinc-100 dark:border-zinc-700 flex flex-col">
        <div class="flex items-center mb-4">
          <div class="bg-orange-100 dark:bg-orange-900 p-3 rounded-full mr-3 w-12 h-12 flex items-center justify-center">
            <i class="pi pi-flag text-2xl text-orange-600 dark:text-orange-400"></i>
          </div>
          <h3 class="text-xl font-bold text-gray-800 dark:text-white">
            Vérification des Priorités
          </h3>
        </div>
        
        <div class="flex-1 flex items-center justify-center my-8">
          <i *ngIf="!loadingStates[BackgroundJobType.PRIORITY]" class="pi pi-check-circle text-green-500 dark:text-green-400" style="font-size: 4rem;"></i>
          <i *ngIf="loadingStates[BackgroundJobType.PRIORITY]" class="pi pi-spin pi-spinner text-orange-500" style="font-size: 4rem;"></i>
        </div>

        <p-button
          label="Lancer"
          icon="pi pi-play"
          [disabled]="loadingStates[BackgroundJobType.PRIORITY]"
          (click)="launchPriorityCheck()"
          class="w-full"
          styleClass="w-full"
        />
      </div>
    </div>
  </div>
</div>
